import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  className: "hold-transition login-page",
  style: {"height":"100%"}
}
const _hoisted_2 = {
  className: "wrapper",
  style: {"height":"100%","padding-top":"60px","background":"#d2d6de"}
}
const _hoisted_3 = { className: "login-box" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { className: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "javascript:;" }, "登录页面")
], -1)
const _hoisted_5 = { className: "login-box-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { className: "login-box-msg" }, "登录你的账号", -1)
const _hoisted_7 = { className: "form-group has-feedback" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { className: "fa fa-user form-control-feedback" }, null, -1)
const _hoisted_9 = { className: "form-group has-feedback" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { className: "fa fa-lock form-control-feedback" }, null, -1)
const _hoisted_11 = { className: "row" }
const _hoisted_12 = { className: "col-xs-8" }
const _hoisted_13 = { className: "checkbox pull-left" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 记住账号 ")
const _hoisted_15 = { className: "col-xs-4" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_input_view = _resolveComponent("input-view")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_input_view, {
              modelValue: $data.account,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.account) = $event)),
              className: "form-control",
              placeholder: "账号"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_input_view, {
              modelValue: $data.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.password) = $event)),
              className: "form-control",
              autocomplete: "new-password",
              type: "password",
              placeholder: "密码"
            }, null, 8, ["modelValue"]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.rememberMe) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, $data.rememberMe]
                  ]),
                  _hoisted_14
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("input", {
                className: "btn btn-primary btn-block btn-flat",
                type: "submit",
                value: "登录",
                onClick: _cache[3] || (_cache[3] = (...args) => ($options.sign && $options.sign(...args)))
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}